// components/ShapeDraw.js
import { useRef } from 'react';
import { FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import L from 'leaflet';


const ShapeDraw = ({ markers, onPolygonCreated }) => {
  const featureGroupRef = useRef();

  const _created = (e) => {
    try {
      const layer = e.layer;
      const polygon = layer.toGeoJSON();

      const markersInside = markers.filter(marker => {
        const lat = parseFloat(marker.lat);
        const lng = parseFloat(marker.lng);
        
        if (lat === undefined || lng === undefined) {
          console.warn('Marker missing coordinates:', marker);
          return false;
        }

        const point = L.latLng(lat, lng);
        const inBounds = layer.getBounds().contains(point);
        
        if (!inBounds) return false;
        
        return inBounds;
      });

      onPolygonCreated({
        polygon,
        markersInside: markersInside.map(m => ({
          ...m,
          lat:m.lat,
          lng:m.lng
        }))
      });

    } catch (error) {
      console.error('Error processing polygon:', error);
    }
  };

  return (
    <FeatureGroup ref={featureGroupRef}>
      <EditControl
        position="topleft"
        onCreated={_created}
        draw={{
          polygon: {
            allowIntersection: false,
            showArea: true
          },
          polyline: true,
          rectangle: false,
          circle: false,
          marker: false,
          circlemarker: false
        }}
      />
    </FeatureGroup>
  );
};

export default ShapeDraw;